import React from "react";
import { useTranslation } from "react-i18next";
import {
  useAddIdentityProvider,
  useRetrieveCurrentPlanzone,
} from "@planzone/view-models";
import { IdentityProvider, identityProvider } from "@planzone/dto";

import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { Props } from "./types";
import { Form } from "./form";
import styles from "./styles.scss";

function AddIdentityProvider({ cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, addIdentityProvider } = useAddIdentityProvider();
  const { planzone } = useRetrieveCurrentPlanzone();
  const [formData, setFormData] = React.useState<IdentityProvider>({
    ...identityProvider,
    name: "cas",
  });

  return (
    <Modal header={t("addIdentityProvider.title")} close={cancel}>
      <div className={styles.addIdentityProvider}>
        <div className={styles.form}>
          <Form formData={formData} edit={setFormData} />
        </div>
        <div className={styles.footer}>
          <Button
            type="submit"
            isDisabled={isRequestPending}
            status={isRequestPending ? "pending" : "none"}
            press={() =>
              addIdentityProvider({
                planzone,
                identityProvider: formData,
              })
            }
          >
            {t("addIdentityProvider.submit")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { AddIdentityProvider };
